// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_usage_view from "./web_usage_view.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function line(value) {
  const partial_arg = value;
  return function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
}

function optional(label) {
  return function (param) {
    return Stdlib__Option.fold(/* [] */ 0, (function (value) {
      return {
        hd: line(label + (": " + value)),
        tl: /* [] */ 0
      };
    }), param);
  };
}

function collection(run) {
  const value = run.collection;
  if (value !== undefined) {
    return Stdlib.$at({
      hd: line("Collection: " + value.state),
      tl: {
        hd: line("Attempts: " + String(value.attempts)),
        tl: /* [] */ 0
      }
    }, optional("Last error")(value.error));
  } else {
    return {
      hd: line("Collection not yet reported"),
      tl: /* [] */ 0
    };
  }
}

function source(value) {
  const partial_arg = "Source: " + value.id;
  const partial_arg$1 = 3;
  const partial_arg$2 = Stdlib.$at({
    hd: (function (param, param$1) {
      return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  }, Stdlib.$at(optional("Connection")(value.connection), Stdlib.$at(optional("Owner")(value.owner), Stdlib.$at(optional("Consumer")(value.consumer), Stdlib.$at(optional("First consuming run")(value.first_run), Stdlib.$at(Stdlib__List.map((function (param) {
    return line(param[0] + (": " + param[1]));
  }), value.evidence), Stdlib__List.concat_map((function (param) {
    return Stdlib.$at({
      hd: line(param[0] + (" \xc2\xb7 " + Mapre_web__Web_usage_view.quantity(param[1]))),
      tl: /* [] */ 0
    }, Stdlib__Option.fold(/* [] */ 0, (function (value) {
      return {
        hd: line("Reported amount: " + Mapre_web__Web_usage_view.amount(value)),
        tl: /* [] */ 0
      };
    }), param[2]));
  }), value.rows)))))));
  const partial_arg$3 = {
    hd: [
      "data-usage-source",
      value.id
    ],
    tl: /* [] */ 0
  };
  const partial_arg$4 = "form-card";
  const partial_arg$5 = 0;
  const partial_arg$6 = 12;
  const partial_arg$7 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function view(model, send) {
  const source$1 = Signal.map((function (m) {
    return m.session_usage;
  }), model);
  const partial_arg = "Session usage";
  const partial_arg$1 = 2;
  const partial_arg$2 = "Loading session usage...";
  const partial_arg$3 = "muted";
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    return p.loading;
  }), source$1);
  const partial_arg$6 = Signal.map((function (p) {
    return p.message !== "";
  }), source$1);
  const partial_arg$7 = {
    TAG: /* Session_usage */ 39,
    _0: {
      TAG: /* Select */ 0,
      _0: undefined
    }
  };
  const partial_arg$8 = (function (param) {
    return Lui_elements.press(send, partial_arg$7, param);
  });
  const partial_arg$9 = "outline";
  const partial_arg$10 = "Back to session usage";
  const partial_arg$11 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$12 = Signal.map((function (p) {
    return p.selected !== undefined;
  }), source$1);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: line("Reported quantities and prices only. Missing evidence is not zero; turn observations are not added to request totals. Provider amounts are not settled bills."),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$6, (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___001_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
                return p.message;
              }), source$1)));
              const partial_arg$1 = "notice";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.dyn(undefined, (function (p) {
              const match = p.detail;
              const match$1 = p.selected;
              const match$2 = p.report;
              if (match !== undefined) {
                const partial_arg = "Run usage";
                const partial_arg$1 = 2;
                const partial_arg$2 = "Reported sources";
                const partial_arg$3 = 3;
                const partial_arg$4 = Stdlib.$at({
                  hd: (function (param, param$1) {
                    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  }),
                  tl: {
                    hd: line("Run: " + match.run.id),
                    tl: {
                      hd: line("State: " + match.run.state),
                      tl: /* [] */ 0
                    }
                  }
                }, Stdlib.$at(collection(match.run), Stdlib.$at(Stdlib__List.map(Mapre_web__Web_usage_view.category_view, match.categories), Stdlib.$at({
                  hd: (function (param, param$1) {
                    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  }),
                  tl: /* [] */ 0
                }, Stdlib.$at(match.truncated ? ({
                    hd: line("Only the first 100 sources are listed; totals include all sources."),
                    tl: /* [] */ 0
                  }) : /* [] */ 0, Caml_obj.caml_equal(match.sources, /* [] */ 0) ? ({
                    hd: line("No source evidence reported."),
                    tl: /* [] */ 0
                  }) : Stdlib__List.map(source, match.sources))))));
                const partial_arg$5 = 0;
                const partial_arg$6 = 12;
                return function (param, param$1) {
                  return Lui_elements.column(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, param, param$1);
                };
              }
              if (match$1 === undefined && match$2 !== undefined) {
                const partial_arg$7 = "Runs";
                const partial_arg$8 = 3;
                const partial_arg$9 = Stdlib.$at({
                  hd: line("Collection: " + match$2.collections),
                  tl: /* [] */ 0
                }, Stdlib.$at(Stdlib__List.map(Mapre_web__Web_usage_view.category_view, match$2.categories), Stdlib.$at({
                  hd: (function (param, param$1) {
                    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  }),
                  tl: /* [] */ 0
                }, Stdlib.$at(match$2.truncated ? ({
                    hd: line("Only the latest 25 runs are listed; totals include all runs."),
                    tl: /* [] */ 0
                  }) : /* [] */ 0, Stdlib__List.mapi((function (index, run) {
                  const partial_arg = {
                    TAG: /* Session_usage */ 39,
                    _0: {
                      TAG: /* Select */ 0,
                      _0: run.id
                    }
                  };
                  const partial_arg$1 = (function (param) {
                    return Lui_elements.press(send, partial_arg, param);
                  });
                  const partial_arg$2 = "View run " + run.id;
                  const partial_arg$3 = "outline";
                  const partial_arg$4 = "Run " + (String(index + 1 | 0) + (" \xc2\xb7 " + run.state));
                  return function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), match$2.runs)))));
                const partial_arg$10 = 0;
                const partial_arg$11 = 12;
                return function (param, param$1) {
                  return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
                };
              }
              return function (param, param$1) {
                return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), source$1, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$12, partial_arg$11, param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___002_) {
                  const partial_arg = {
                    TAG: /* Session_usage */ 39,
                    _0: /* Refresh */ 1
                  };
                  const partial_arg$1 = (function (param) {
                    return Lui_elements.press(send, partial_arg, param);
                  });
                  const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
                    return p.loading;
                  }), source$1)));
                  const partial_arg$3 = "outline";
                  const partial_arg$4 = "Refresh session usage";
                  return function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const partial_arg$13 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$14 = "session-usage-view";
  const partial_arg$15 = 0;
  const partial_arg$16 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
